import { useState } from 'react';

/**
 * Custom hook to handle form controls.
 * @param {Array} inputFieldsValues - An array of input field objects.
 * @returns {Object} An object containing form values, errors, and handler functions.
 */
export function useFormControls(inputFieldsValues) {
  // Initialize form values
  const initialValues = inputFieldsValues.reduce((obj, item) => ({ ...obj, [item.name]: '' }), {});

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});

  // Function to validate form fields
  const validate = (key, value) => {
    const field = inputFieldsValues.find((inpt) => inpt.name === key);
    const errors = { ...formErrors };

    if (field.required) {
      errors[key] = value ? '' : '*Ce champ est requis.';
    }

    if (value !== '' && field.type === 'email') {
      errors.email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) ? '' : 'Adresse e-mail non valide.';
    }

    setFormErrors(errors);
  };

  // Function to handle input value changes
  const handleInputValue = ({ target }) => {
    const { name, value } = target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    validate(name, value);
  };

  // Function to reset form
  const resetForm = () => {
    setFormValues(initialValues);
  };

  // Function to check if form is valid
  const isValid = () => {
    return (
      Object.values(formErrors).every((x) => x === '') &&
      Object.entries(formValues).every(([k, v]) =>
        inputFieldsValues.find((inpt) => inpt.name === k).required ? v !== '' : true,
      )
    );
  };

  return {
    handleInputValue,
    isValid,
    formErrors,
    formValues,
    resetForm,
  };
}
